// extracted by mini-css-extract-plugin
export default {"buttons-wrapper":"buttons-wrapper--AsV_VdxBvF","buttonsWrapper":"buttons-wrapper--AsV_VdxBvF"};